import React from 'react';
import { useState } from 'react';
import { formatDate, formatToCurrencyWithScale } from '../../../helpers/FormatHelper';
import { searchCustomerByIdNameMin } from '../../../networking/NetworkingCustomers';
import { getTransferStatement } from '../../../networking/NetworkingFunds';
import { getStyle } from '../../../styles/styles';
import useCurrenciesList from '../../maintenance/blotter/hooks/useCurrenciesList';
import DatePicker from '../../shared/DatePicker';
import DynamicSearchSelect from '../../shared/DynamicSearchSelect';
import DynamicSelect from '../../shared/DynamicSelect';
import NewDynamicTable from '../../shared/NewDynamicTable';
const style = getStyle();

const HeldFundsBalanceTransferStatementScreen = () => {
    const [currencies] = useCurrenciesList();
    const [transferStatement, setTransferStatement] = useState([]);
    const [validations, setValidations] = useState({
        customerSelectedFilter: true,
        currencyIDFilter: true,
        fromDateFilter: true,
        toDateFilter: true,
    });

    const [customerSelectedFilter, setCustomerSelectedFilter] = useState({ value: 0, name: '' });
    const [currencyIDFilter, setCurrencyIDFilter] = useState({ value: '', name: '' });
    const [fromDateFilter, setFromDateFilter] = useState('');
    const [toDateFilter, setToDateFilter] = useState('');
    const [customerListFilter, setCustomerListFilter] = useState([]);
    
    const getTransferStatementClick = async () => {
        const json = await getTransferStatement(checkZero(customerSelectedFilter.value), checkEmpty(currencyIDFilter.value), checkEmpty(fromDateFilter), checkEmpty(toDateFilter));
        if (json != null && json.result != null) {
            setTransferStatement(json.result);
        } else {
            setTransferStatement([]);
        }
    };
    
    const clearFilterClick = () => {
        setCustomerSelectedFilter({ value: 0, name: '' });
        setCurrencyIDFilter({ value: '', name: '' });
        setFromDateFilter('');
        setToDateFilter('');
        setCustomerListFilter([]);
        setTransferStatement([]);
        setValidations({
            customerSelectedFilter: true,
            currencyIDFilter: true,
            fromDateFilter: true,
            toDateFilter: true
        });
    };
    
    const searchCustomerFilter = (query) => {
        if (query === '') {
            setCustomerListFilter([]);
        } else {
            searchCustomerByIdNameMin(query).then(
                (response) => {
                    if (response.customers !== undefined) {
                        for (var i = 0; i < response.customers.length; i++) {
                            response.customers[i].value = response.customers[i].CustomerID;
                            response.customers[i].name = response.customers[i].CustomerIDName;
                        }
                        setCustomerListFilter(response.customers);
                    }
                }
            )
        }
    };
    
    const handleUpdateCustomerFilter = (value) => {
        if (value.value !== undefined) {
            setCustomerSelectedFilter(value.value !== 'select' ? value : 0);
            setValidations({ ...validations, customerSelectedFilter: true });
            setCustomerListFilter([]);
        }
    };
    
    const handleGetValueCurrencyFilter = (value) => {
        if (value != null && value !== 'select' && value.value !== undefined) {
            setCurrencyIDFilter(value);
            setValidations({ ...validations, currencyIDFilter: true });
        }
    };

    const handleUpdateFromDateFilter = (date) => {
        setFromDateFilter(formatDate(date));
        setValidations({ ...validations, fromDateFilter: true });
    };

    const handleUpdateToDateFilter = (date) => {
        setToDateFilter(formatDate(date));
        setValidations({ ...validations, toDateFilter: true });
    };

    const checkZero = (value) => value !== 0 ? value : null;

    const checkEmpty = (value) => value !== '' ? value : null;

    return(
        <div className='uk-grid'>
            <div className="uk-width-1-1 uk-margin">
                <form className="uk-form-horizontal">
                    <div className="uk-grid">
                        <div className="uk-width-1-4 uk-form-stacked">
                            <label className="uk-form-label" style={style.boldLabel}>Customer (*)</label>
                            <div className="" style={{ paddingBottom: "5px" }}>
                                <DynamicSearchSelect
                                    className="uk-input"
                                    id="select-customer-filter"
                                    placeholder="Select a Customer..."
                                    searchFunction={(query) => searchCustomerFilter(query, 'Receiving')}
                                    getValue={(event) => handleUpdateCustomerFilter(event)}
                                    data={customerListFilter}
                                    objValue={{ value: customerSelectedFilter.value, name: customerSelectedFilter.name }}
                                />
                            </div>
                        </div>
                        <div className="uk-width-1-4 uk-form-stacked">
                            <label className="uk-form-label" style={style.boldLabel}>Currency (*)</label>
                            <div className="" style={style.inputStyle}>
                                <DynamicSelect
                                    className="uk-select"
                                    objValue={{ value: currencyIDFilter.value, name: currencyIDFilter.name }}
                                    getValue={handleGetValueCurrencyFilter}
                                    listHasPlaceholder={false}
                                    placeholder={"Select a Currency..."}
                                    data={currencies}
                                    id="form-commission-currencies-filter"
                                />
                            </div>
                        </div>                        
                    </div>
                    <div className="uk-grid grid-margin-15">
                        <div className="uk-width-1-4 uk-form-stacked">
                            <label className="uk-form-label" style={style.boldLabel}>From Date</label>
                            <div className="" style={{ paddingBottom: "5px" }}>
                                <DatePicker
                                    useNew
                                    value={fromDateFilter}
                                    onDayChange={handleUpdateFromDateFilter}
                                    className='uk-input'
                                    id="from-date-filter"
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <div className="uk-width-1-4 uk-form-stacked">
                            <label className="uk-form-label" style={style.boldLabel}>To Date</label>
                            <div className="" style={{ paddingBottom: "5px" }}>
                                <DatePicker
                                    useNew
                                    value={toDateFilter}
                                    onDayChange={handleUpdateToDateFilter}
                                    className='uk-input'
                                    id="from-date-filter"
                                    readOnly={true}
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div className="uk-width-1-1">
                <button className="uk-button uk-button-green uk-margin-right" onClick={getTransferStatementClick}>Search</button>
                <button className="uk-button uk-button-green uk-margin-right" onClick={clearFilterClick}>Clear Filter</button>
            </div>
            <div className="uk-width-1-1">
                <NewDynamicTable
                    hiddenHeaders={['Key', 'Action']}
                    data={transferStatement}
                    useExportButton={true}
                    formats={[{ header: 'Amount', formatFunction: formatToCurrencyWithScale, formatCurrency:'Currency' }]}
                    tableName="transfers" />
            </div>
        </div>
    )
}

export default HeldFundsBalanceTransferStatementScreen